import { isPreviewingPack, isSharedPack } from "lib/utils/pack";
import { useRouter } from "next/router";
import { useCookies } from "react-cookie";
import { usePack } from "./usePack";
import { useAppSelector } from "lib/redux";
import { selectMe } from "domains/account";

export const useStickyAd = (packId) => {
  const { pathname } = useRouter();
  const [cookie, setCookie] = useCookies(['hideAd']);
  const hideAd = cookie.hideAd && JSON.parse(cookie.hideAd);
  const { data, error } = usePack(packId);
  const me = useAppSelector(selectMe);

  
  return {
    displayAd: data && !error && !hideAd && (!me?.permissions && isSharedPack(data?.id) || isPreviewingPack(pathname)),
    setHideAd: (value: boolean) => setCookie('hideAd', JSON.stringify(value))
  }
}
